/* eslint-disable */
import React, { createContext, useContext } from 'react';

interface TranslationContextType {
	t: (key: string, options?: { [key: string]: any }) => string;
}

const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export const TranslationProvider: React.FC<{ children: React.ReactNode; t: any }> = ({
	children,
	t,
}) => {
	return <TranslationContext.Provider value={{ t }}>{children}</TranslationContext.Provider>;
};

export const useTranslationContext = (): TranslationContextType => {
	const context = useContext(TranslationContext);
	if (!context) {
		throw new Error('useTranslationContext must be used within a TranslationProvider');
	}
	return context;
};
